<template>
  <div>
    <div class="content-header" style="border: none">
      <div class="left">
        <span class="title">产品更新说明</span>
      </div>
      <div class="right">
        <Button v-if="user.tp" type="primary" @click="$router.push({ name: 'download' })"
          >下载最新版本</Button
        >
        <Button v-else type="primary" @click="edit">{{
          isEdit ? "完成" : "编辑"
        }}</Button>
        <Button v-if="!user.tp" type="primary" @click="msgPush" style="margin-left: 10px"
          >消息推送</Button
        >
        <Button style="margin-left: 15px" @click="$router.back()">{{
          user.tp ? "返回" : "取消"
        }}</Button>
      </div>
    </div>
    <Tabs class="list-tab" v-model="tab_val" @on-click="typeClick">
      <TabPane label="通用基础版" name="1"></TabPane>
      <TabPane label="服务窗口版" name="2"></TabPane>
      <TabPane label="智能运维" name="3"></TabPane>
    </Tabs>
    <div v-if="!isEdit" class="update" v-html="content"></div>
    <vue-editor
      v-else
      class="editor"
      v-model="content"
      useCustomImageHandler
    ></vue-editor>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
export default {
  components: { VueEditor },
  data () {
    return {
      tab_val: '1',
      content: '',
      isEdit: false
    }
  },
  methods: {
    getData () {
      this.GetUpdateNotice({
        type: this.tab_val
      }).then((result) => {
        console.log('结果', result)
        this.content = result.text
      })
    },
    typeClick () {
      this.getData()
    },
    edit () {
      if (this.isEdit) {
        this.EditUpdateNotice({
          type: this.tab_val,
          text: this.content
        }).then((result) => {
          this.$Message.success('保存成功')
          this.getData()
        })
      }
      this.isEdit = !this.isEdit
    },
    // 消息推送
    msgPush () {
      this.$Modal.confirm({
        title: `温馨提示`,
        content: `是否确定推送消息?`,
        onOk: () => {
          this.MsgPush({ type: 0 }).then((res) => {
            console.log('消息推送成功')
            this.$Message.success('消息推送成功')
          })
        }
      })
    },
    ...mapActions(['GetUpdateNotice', 'EditUpdateNotice', 'MsgPush'])
  },
  mounted () {
    // this.page.start = this.$moment(new Date(), "YYYY-MM-DD");
    // this.page.end = this.$moment(new Date(), "YYYY-MM-DD");
    this.getData()
  },
  computed: mapGetters({
    user: 'agent'
  }),
  watch: {
    col: {
      handler (n, o) {
        this.formatCol()
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
